import type { FaireProductEntity } from "../../entity_types/product";

export const p_2tw29tn6ka: FaireProductEntity = {
  token: "p_2tw29tn6ka",
  type: "product",
  name: "Kid/Baby 2-Tone Cap: Certified Mamas Boy Brown/Beige",
  brandToken: "b_ee3ulfd69w",
  brandName: "Funky Junque",
  imageUrl:
    "https://cdn.faire.com/fastly/61231526abdec97bf1625990f92eea2706d25a598efe30b1ad24dc43eaf02aef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/870f9c0bd9fdc0b90e025037b286827e22236abd11ba0f040315c2f28cc5fdf1.jpeg",
    "https://cdn.faire.com/fastly/6c5be391112391606327a768bf5e7290f5249d06d7e2c1318a28aa01086f3216.jpeg",
    "https://cdn.faire.com/fastly/459f3e50e4e2a4fa1e27d20745d6e99116e09e8e918db76aab16f652992a991b.jpeg",
    "https://cdn.faire.com/fastly/d8f122d83135aa1aaaba355d30530b036bd4620141fb10e44319d9b787843a2d.jpeg",
    "https://cdn.faire.com/fastly/3984425e421428b0cd1bdb25868c0b8eb72ff040080ca60d79b954ba844033d6.jpeg",
    "https://cdn.faire.com/fastly/377c3b04ec32392bf1a25ca0e14465f48318fa43bae4966c4e687aa187558456.jpeg",
  ],
  priceDollars: 11,
  description:
    "Made from 35% cotton and 65% polyester, this kids & infant baseball cap offers durability, comfort, and a stylish two-tone vintage design. Ideal for pairing with baby boy outfits or toddler essentials, it’s perfect for newborns and kids alike. Designed to protect delicate heads, it provides a snug, breathable fit and shields against the sun for year-round safety. The adjustable snapback ensures a customizable fit for growing children, available in three sizes: X-Small (0-12 months), Small (12-24 months), and Medium/Large (2-9 years). Whether as a baby baseball cap, toddler trucker hat, or youth snapback, this versatile accessory combines practicality, comfort, and style for all occasions.",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:38.311Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
